import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Flex,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import Button from './Button';
import { CreateExpectedNewSCN, CreateSCN, SaveInventoryStock } from '../Utils/ApiCalls';
import { SiQuantcast } from 'react-icons/si';
import { ImPriceTag } from 'react-icons/im';
import MsgCallback from './MsgCallback';
import ScnCard from './ScnCard';



export default function CreateReturnToShelf({ isOpen, onOpen, onClose, state, updatedPayload, sendingId }) {

    const [Payload, setPayload] = useState({
        scn: [
            {
                shelfid: "",
                qtyreturned: "",
                price: "",
                returneedepartment: "",
                returnby: "", 
                store: ""
            }
        ]

    });

    const [ExpectedPayload, setExpectedPayload] = useState({
        qtyreturned: "",
        price: ""
    });
    const [StockPayload, setStockPayload] = useState({
        shelfid: "",
        countedqty: "",
        countedqtyserviceable: "",
        countedqtyunserviceable: "",
        store: ""
    });

    const handleStockPayload = (e) => {
        setStockPayload({ ...StockPayload, [e.target.id]: e.target.value })

    }

    console.log("sendingId", sendingId)
    console.log("StockPayload", StockPayload)



    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: ""
    });


    const [Loading, setLoading] = useState(false);


    // Onchange handler for RTS
    const handleRTS = (e) => {
        setPayload({ ...Payload, [e.target.id]: e.target.value })

    }





    const CreateNewSCN = async () => {

        try {
            setLoading(true)
            let result = await CreateSCN(Payload.scn);
            // console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Store Credit created successfully"
                })

                setPayload({
                    scn: [
                        {
                            shelfid: "",
                            qtyreturned: "",
                            price: "",
                            returneedepartment: "",
                            returnby: "",
                            store: "",
                        }
                    ]
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            // console.error('Error:', e.message);
        }



    }

    const handleReturnby =  (e) =>{
        setExpectedPayload(
            {...ExpectedPayload , [e.target.id]: e.target.value}
        )
    }


    const CreateExpectedSCN =async ()=>{
        try {
            setLoading(true)
            let result = await CreateExpectedNewSCN(ExpectedPayload, sendingId);
            console.log("resultexpected", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Store Credit Note created successfully"
                })

                setExpectedPayload({
                    qtyreturned: "",
                    price: ""
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })
                }, 6000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 6000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            // console.error('Error:', e.message);
        }


    }

    const SaveStock = async ()=>{
        try {
            setLoading(true)
            let result = await SaveInventoryStock(StockPayload,sendingId.id);
            console.log("TakeProductStock", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Stock Taken successfully"
                })
                setTimeout(() => {
                    onClose()
                }, 1000);

                setStockPayload({
                    shelfid: "",
                    countedqty: "",
                    countedqtyserviceable: "",
                    countedqtyunserviceable: "",
                    store: ""
                })

               

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                    })
                },6000);

                setTimeout(() => {
                 onClose()
                }, 4000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 6000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            // console.error('Error:', e.message);
        }


    }
  

    useEffect(() => {

      
        setStockPayload({
            
            countedqty: sendingId?.item?.countedqty,
            countedqtyserviceable: sendingId?.item?.countedqtyserviceable,
            countedqtyunserviceable: sendingId?.item?.countedqtyunserviceable,
            store: sendingId?.store
        })

    }, [isOpen]);

    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{ state === "scn" || state === "expectedScn" ? "Create New Return To Store": `Count Stock for ${sendingId?.name}`} </ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                {
                    state === "scn" && (
                        <Stack>

                        <Flex cursor={"pointer"} justifyContent="flex-end" onClick={() => setPayload(

                            {
                                ...Payload,
                                scn: [...Payload.scn, {
                                    shelfid: "",
                                    qtyreturned: "",
                                    price: "",
                                    returneedepartment: "",
                                    returnby: "",
                                    store: ""
                                },]
                            }
                        )}>Add more <span>+</span></Flex>

                        {
                            Payload.scn.map((item,i)=>(
                                <ScnCard
                                  data={item} oldItem={Payload.scn} Payload={Payload} setPayload={setPayload} key={i} i={i}
                                />
                            ))
                        }

                        <Button onClick={CreateNewSCN} isLoading={Loading}>Proceed</Button>

                        <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                    </Stack>
                    )
                }

                    {
                    state === "expectedScn" && (
                        <Stack>

                       
                        <Input  leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='quantity returned' id="qtyreturned" type='number' value={ExpectedPayload.qtyreturned} val={ExpectedPayload.qtyreturned != "" ? true : false} onChange={handleReturnby} />
                        <Input  leftIcon={<ImPriceTag />} iconColor="black" labelBg='#fff' label='price' id="price" type='number' value={ExpectedPayload.price} val={ExpectedPayload.price != "" ? true : false} onChange={handleReturnby} />

                        <Button onClick={CreateExpectedSCN} disabled={ExpectedPayload.qtyreturned !=="" ? false: true } isLoading={Loading}>Proceed</Button>

                        <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                    </Stack>
                    )
                }
                    {
                    state === "takeStock" && (
                        <Stack>

                       
                        <Input  leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Counted Good Quantity' id="countedqty" type='number' value={StockPayload.countedqty} val={StockPayload.countedqty != "" ? true : false} onChange={handleStockPayload} />
                        <Input  leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Counted Quantity Serviceable' id="countedqtyserviceable" type='number' value={StockPayload.countedqtyserviceable} val={StockPayload.countedqtyserviceable != "" ? true : false} onChange={handleStockPayload} />
                        <Input  leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Counted Quantity UnServiceable' id="countedqtyunserviceable" type='number' value={StockPayload.countedqtyunserviceable} val={StockPayload.countedqtyunserviceable != "" ? true : false} onChange={handleStockPayload} />

                        <Button mt="32px" onClick={SaveStock} disabled={StockPayload.countedqty !=="" && StockPayload.countedqtyserviceable !=="" && StockPayload.countedqtyunserviceable !=="" ? false: true } isLoading={Loading}>Save </Button>

                        <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                    </Stack>
                    )
                }
                    

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
